import React from 'react';

import { SplitCellsOutlined, TableOutlined } from '@ant-design/icons';

import { Radio, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';

import { useLocalDispatch, useLocalSelector } from '@app/services/hooks/useRedux';
import { setValue } from '@app/store/currentSessionReducer';
import { OrdersViewType } from '@app/store/currentSessionReducer/interfaces';

export const ViewSwitch: React.FC = () => {
  const ordersT = useTranslation(NSKeys.orders);
  const activeView = useLocalSelector((state) => state.currentSession.ordersListView);
  const dispatch = useLocalDispatch();

  const handleChange = (view: OrdersViewType) => {
    dispatch(setValue({ ordersListView: view }));
  };

  return (
    <Radio.Group
      defaultValue={activeView}
      size="middle"
      buttonStyle="solid"
      style={{ display: 'flex', flexWrap: 'nowrap' }}
      onChange={(e) => handleChange(e.target.value)}>
      <Tooltip title={ordersT.t('switchViewList')}>
        <Radio.Button value={OrdersViewType.LIST}>
          <TableOutlined />
        </Radio.Button>
      </Tooltip>
      <Tooltip title={ordersT.t('switchViewBoard')}>
        <Radio.Button value={OrdersViewType.BOARD}>
          <SplitCellsOutlined />
        </Radio.Button>
      </Tooltip>
    </Radio.Group>
  );
};
